import { useEffect, useState } from "react";
import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { VideoSection } from "@/components/landing/VideoSection";
import { DriverBento } from "@/components/landing/DriverBento";
import { Waitlist } from "@/components/landing/Waitlist";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Footer } from "@/components/landing/Footer";
import { BlogTeaser } from "@/components/landing/BlogTeaser";

export default function Landing() {
  const [role, setRole] = useState("driver");
  const [params] = useState(() => new URLSearchParams(window.location.search));
  const refCode = (params.get("ref") || "").toUpperCase();
  const statusCode = (params.get("status") || "").toUpperCase();

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (!refCode && !statusCode && !hash) return;
    const target = refCode || statusCode ? "signup" : hash;
    const t = setTimeout(() => document.getElementById(target)?.scrollIntoView({ behavior: "smooth" }), 900);
    return () => clearTimeout(t);
  }, [refCode, statusCode]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest('a[href="#signup"]');
      if (a) setRole(a.dataset.role === "customer" ? "customer" : "driver");
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return (
    <main data-testid="landing-page">
      <SmoothScroll />
      <Nav />
      <Hero />
      <Marquee />
      <VideoSection />
      <DriverBento />
      <Waitlist role={role} setRole={setRole} refCode={refCode} statusCode={statusCode} />
      <HowItWorks />
      <BlogTeaser />
      <Footer />
    </main>
  );
}
